import styled from 'styled-components/macro';
import { mediaDesktop } from 'breakpoints';
import theme from 'components/theme';
import Typography from 'components/Typography';
import { type TypographyProps } from 'components/Typography/types';

export const StyleCollectionsHeadline = styled(Typography)< TypographyProps >`
  letter-spacing: 1px;
  margin-bottom: 0;
  line-height: 1.5;
  
  ${mediaDesktop} {
    letter-spacing: 2px;
  }
`;

export const OtherCollectionsWrapper = styled.section`
  background: ${theme.colors.dark};
  display: grid;
  overflow-x: hidden;
  grid-gap: 28px;
  padding: 22px 16px 32px;
  place-content: center;
  /* max-width: 976px; */
  ${mediaDesktop} {
    grid-gap: 55px;
    grid-template-columns: minmax(min-content,978px);
    padding: 0px 24px 100px;
  }
`;
